// All Modules
export const GET_MODULES = "GET_MODULES"
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS"
export const GET_MODULES_FAIL = "GET_MODULES_FAIL"
